/**
 * 合并行或列的计算方法
 */
export function mergeTableSpanMethod({ row, column, rowIndex, columnIndex }){
  if(row.isNeedInquiry || row.exemptionType === 2){
    console.log({ row, column, rowIndex, columnIndex })
    let priceList = row.priceList || [];
    let priceColumnNumber = priceList.length; //报价列的列数量
    let startColumnNumber = 4;//报价列 之前的列数量
    let endColumnNumber = 2;//报价列 之后的列数量
    if(this.isDeliveryType) {
      if(this.isSupportMultiChannel){
        // priceColumnNumber += 3;
      }else{
        // priceColumnNumber += 2;
      }
      startColumnNumber = 1;
    }
    if( columnIndex > (startColumnNumber - 1) && columnIndex <= (priceColumnNumber + startColumnNumber - 1) ){
      console.log("是报价列");
      if(columnIndex === startColumnNumber){
        return [1,priceColumnNumber];
      }else{
        return [1,0];
      }
    }
  }
  return [1,1];
}



// WEBPACK FOOTER //
// ./src/components/QuotationManagement/components-productQuotation/cityCustomQuotationList/utils.js